// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-menu-admin{
    padding-top: 15px;
    justify-content: center;
    display: flex;
    gap: 20px;
}

/* Status Check Modal Styles */
.status-modal .Polaris-Modal__Body {
    max-height: 85vh;
    overflow-y: auto;
    padding: 20px;
}

.status-modal .Polaris-Card {
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border: 1px solid #e1e3e5;
    margin-bottom: 16px;
}

.status-modal .Polaris-BlockStack > .Polaris-BlockStack__Item:not(:last-child) {
    margin-bottom: 20px;
}

.status-modal .Polaris-Text--headingLg {
    font-weight: 700;
    color: #202223;
    margin: 0;
}

.status-modal .Polaris-Text--headingMd {
    font-weight: 600;
    color: #202223;
    margin: 0;
}

.status-modal .Polaris-Text--headingSm {
    font-weight: 500;
    color: #202223;
    margin: 0;
}

.status-modal .Polaris-Text--bodyLg {
    font-size: 16px;
    line-height: 1.5;
}

.status-modal .Polaris-Text--fontFamilyMono {
    font-family: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;
    background: #f6f6f7;
    padding: 12px 16px;
    border-radius: 6px;
    border: 1px solid #e1e3e5;
    font-size: 14px;
}

.status-modal .Polaris-Button--plain {
    padding: 8px 0;
    text-align: left;
    width: 100%;
    justify-content: space-between;
    font-weight: 600;
}

.status-modal .Polaris-Button--plain:hover {
    background: #f6f6f7;
    border-radius: 6px;
}

.status-modal .Polaris-Collapsible {
    margin-top: 16px;
}

.status-modal .Polaris-List {
    margin: 12px 0;
}

.status-modal .Polaris-List__Item {
    margin: 6px 0;
    line-height: 1.6;
    font-size: 15px;
}

.status-modal .Polaris-Banner {
    margin: 16px 0;
    border-radius: 8px;
}

.status-modal .Polaris-InlineStack--alignSpaceBetween {
    width: 100%;
}

/* Icon colors */
.status-modal .Polaris-Icon--colorSuccess {
    color: #008060;
}

.status-modal .Polaris-Icon--colorWarning {
    color: #ffc453;
}

.status-modal .Polaris-Icon--colorInfo {
    color: #5c6ac4;
}

/* Modal header improvements */
.status-modal .Polaris-Modal__Header {
    padding: 24px 24px 0 24px;
    border-bottom: 1px solid #e1e3e5;
}

.status-modal .Polaris-Modal__Title {
    font-weight: 700;
    font-size: 20px;
}

/* Primary button improvements */
.status-modal .Polaris-Button--primary {
    font-weight: 600;
    padding: 12px 24px;
    border-radius: 8px;
}

`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,aAAa;IACb,SAAS;AACb;;AAEA,8BAA8B;AAC9B;IACI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kGAAkG;IAClG,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA,gBAAgB;AAChB;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,8BAA8B;AAC9B;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA,gCAAgC;AAChC;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB","sourcesContent":[".header-menu-admin{\r\n    padding-top: 15px;\r\n    justify-content: center;\r\n    display: flex;\r\n    gap: 20px;\r\n}\r\n\r\n/* Status Check Modal Styles */\r\n.status-modal .Polaris-Modal__Body {\r\n    max-height: 85vh;\r\n    overflow-y: auto;\r\n    padding: 20px;\r\n}\r\n\r\n.status-modal .Polaris-Card {\r\n    border-radius: 12px;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n    border: 1px solid #e1e3e5;\r\n    margin-bottom: 16px;\r\n}\r\n\r\n.status-modal .Polaris-BlockStack > .Polaris-BlockStack__Item:not(:last-child) {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.status-modal .Polaris-Text--headingLg {\r\n    font-weight: 700;\r\n    color: #202223;\r\n    margin: 0;\r\n}\r\n\r\n.status-modal .Polaris-Text--headingMd {\r\n    font-weight: 600;\r\n    color: #202223;\r\n    margin: 0;\r\n}\r\n\r\n.status-modal .Polaris-Text--headingSm {\r\n    font-weight: 500;\r\n    color: #202223;\r\n    margin: 0;\r\n}\r\n\r\n.status-modal .Polaris-Text--bodyLg {\r\n    font-size: 16px;\r\n    line-height: 1.5;\r\n}\r\n\r\n.status-modal .Polaris-Text--fontFamilyMono {\r\n    font-family: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;\r\n    background: #f6f6f7;\r\n    padding: 12px 16px;\r\n    border-radius: 6px;\r\n    border: 1px solid #e1e3e5;\r\n    font-size: 14px;\r\n}\r\n\r\n.status-modal .Polaris-Button--plain {\r\n    padding: 8px 0;\r\n    text-align: left;\r\n    width: 100%;\r\n    justify-content: space-between;\r\n    font-weight: 600;\r\n}\r\n\r\n.status-modal .Polaris-Button--plain:hover {\r\n    background: #f6f6f7;\r\n    border-radius: 6px;\r\n}\r\n\r\n.status-modal .Polaris-Collapsible {\r\n    margin-top: 16px;\r\n}\r\n\r\n.status-modal .Polaris-List {\r\n    margin: 12px 0;\r\n}\r\n\r\n.status-modal .Polaris-List__Item {\r\n    margin: 6px 0;\r\n    line-height: 1.6;\r\n    font-size: 15px;\r\n}\r\n\r\n.status-modal .Polaris-Banner {\r\n    margin: 16px 0;\r\n    border-radius: 8px;\r\n}\r\n\r\n.status-modal .Polaris-InlineStack--alignSpaceBetween {\r\n    width: 100%;\r\n}\r\n\r\n/* Icon colors */\r\n.status-modal .Polaris-Icon--colorSuccess {\r\n    color: #008060;\r\n}\r\n\r\n.status-modal .Polaris-Icon--colorWarning {\r\n    color: #ffc453;\r\n}\r\n\r\n.status-modal .Polaris-Icon--colorInfo {\r\n    color: #5c6ac4;\r\n}\r\n\r\n/* Modal header improvements */\r\n.status-modal .Polaris-Modal__Header {\r\n    padding: 24px 24px 0 24px;\r\n    border-bottom: 1px solid #e1e3e5;\r\n}\r\n\r\n.status-modal .Polaris-Modal__Title {\r\n    font-weight: 700;\r\n    font-size: 20px;\r\n}\r\n\r\n/* Primary button improvements */\r\n.status-modal .Polaris-Button--primary {\r\n    font-weight: 600;\r\n    padding: 12px 24px;\r\n    border-radius: 8px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
